import { useSheetContext } from "@/context/sheet";

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "./-form";
import {
  useCreatePaymentAdjustment,
  useUpdatePaymentAdjustment,
} from "@/hooks/payment-adjustment";
import { CreatePaymentAdjustment } from "@/models/payment-adjustment";
import { DomainUpsertLoadingList } from "@/components/domain";
import { useGetReservationClients } from "@/hooks/reservation-clients";

export const Route = createFileRoute(
  "/(payment-adjustments)/payment-adjustments/$id/_sheet/new",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { isLoading: clientsLoading, data: clientsData } =
    useGetReservationClients(id);

  const { close } = useSheetContext();
  const navigate = useNavigate();

  const { mutateAsync } = useCreatePaymentAdjustment();

  //Temp martelada
  const { mutateAsync: updateMutateAsync } = useUpdatePaymentAdjustment({
    onSuccess: (paymentAdjustment) => {
      close(() => {
        navigate({
          to: "/payment-adjustments/$id",
          params: { id: paymentAdjustment.reservationId.toString() },
        });
      });
    },
  });

  const create = async (createPaymentAdjustment: CreatePaymentAdjustment) => {
    const pa = await mutateAsync({
      ...createPaymentAdjustment,
      paymentAdjustmentReservationClients: [],
    });
    const clients =
      createPaymentAdjustment.paymentAdjustmentReservationClients?.map(
        (client) => ({ ...client, paymentAdjustmentId: pa.id }),
      ) ?? [];
    await updateMutateAsync({
      ...createPaymentAdjustment,
      id: pa.id!,
      paymentAdjustmentReservationClients: clients,
    });
  };

  if (clientsLoading) {
    return <DomainUpsertLoadingList />;
  }

  return (
    <Form
      onUpsert={create}
      reservationId={id}
      reservationClients={clientsData ?? []}
    />
  );
}
